import React, { useState } from 'react';
import { Menu, MenuItem, IconButton, Avatar, Divider, ListItemIcon } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { routes } from '../../config/utility';
import {
  Logout as LogoutIcon,
  Person as PersonIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';
import NotificationDropdown from '../NotificationDropdown';

const Headerbar = ({ user, roles, isSidebarOpen, setShowLogoutModal }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  // const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);
  const navigate = useNavigate(); // Initialize useNavigate

  // Handle profile menu
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleProfileMenuClose = () => {
    setAnchorEl(null);
  };

  // Handle notifications menu
  // const handleNotificationMenuOpen = (event) => {
  //   setNotificationAnchorEl(event.currentTarget);
  // };

  // const handleNotificationMenuClose = () => {
  //   setNotificationAnchorEl(null);
  // };

  const logoutHandle = () => {
    setAnchorEl(null);
    setShowLogoutModal(true)
  };

  // Navigate to Profile Page
  const handleProfileClick = () => {
    handleProfileMenuClose();
    if (user && user.username) {
      const profileUrl = routes.profile.replace(':username?', user.username);
      navigate(profileUrl);
    } else {
      // User data is not available
    }
  };

  return (
    // <div className="bg-transparent w-full h-20 flex items-center justify-between px-8 mb-1 mt-4">
    <div className={`backdrop-blur-lg rounded-b-3xl sm:rounded-none w-full fixed top-0 sm:ml-4 z-20  py-2  h-16 sm:py-10
      flex items-center sm:justify-between sm:px-4 transition-all  ${isSidebarOpen ? ' sm:w-[calc(100%-16rem)]' : ' sm:w-[calc(100%-4rem)]'}`}>


      {/* Left Section: Logo - Hidden on mobile, visible on SM and up */}
      <div className="hidden sm:flex items-center space-x-1 ">
        <img src="/assets/paw-full-logo.png" alt="Pawdash Logo" className="h-12" />
      </div>

      {/* Center Logo - Visible only on mobile */}
      {roles.includes('admin') && (
        <>
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 sm:hidden">
            <img src="/assets/paw-full-logo.png" alt="Pawdash Logo" className="h-8" />
          </div>
        </>
      )}

      {roles.includes('user') && (
        <>
          <div className="absolute left-2 top-1/2 -translate-y-1/2 sm:hidden">
            <img src="/assets/paw-full-logo.png" alt="Pawdash Logo" className="h-9" />
          </div>
        </>
      )}




      {/* Search Bar */}
      {/* {roles.includes('admin') && (
        <div className="flex-grow mx-12 relative max-w-4xl hidden sm:block">
          <input
            type="text"
            placeholder="Search"
            className="w-full py-4 px-6 rounded-full bg-white focus:outline-none focus:ring-2 focus:ring-indigo-400 shadow-md text-gray-600 placeholder-gray-400 transition"
          />
          <SearchIcon className="absolute top-4 right-6 text-gray-400" />
        </div>
      )} */}

      {/* Right Section: Notifications and Profile */}
      <div className="absolute top-1 sm:top-0 right-1 sm:right-4 sm:relative flex items-center gap-2 sm:gap-4">
        {/* Notification Section */}
        <NotificationDropdown />


        {/* Profile Section */}
        <div className="relative">
          {/* Profile Dropdown */}

          <div>
            <IconButton
              onClick={handleProfileMenuOpen}
              className="relative  sm:p-3 sm:bg-gradient-to-br from-bodyMain to-primary text-white rounded-full sm:shadow-lg hover:shadow-primary hover:scale-105 transition-transform"
            >
              <Avatar
                alt={user?.name || 'User Avatar'}
                src={user?.profile_photo || '/assets/default-avatar.png'}
                className="w-8 h-8 sm:w-10 sm:h-10 border-1"
              />
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleProfileMenuClose}
              PaperProps={{
                style: {
                  width: '240px',
                  borderRadius: '12px',
                  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                  backgroundColor: '#FFFFFF',
                },
              }}
            >
              <div className="p-4 bg-bodyMain">
                <h4 className="text-lg font-medium text-dark">{user?.name || 'User Name'}</h4>
                <p className="text-sm text-gray-500">{user?.email || 'user@example.com'}</p>
              </div>
              <Divider />
              <MenuItem onClick={handleProfileClick} className="py-3 hover:bg-light">
                <ListItemIcon>
                  <PersonIcon className="text-primary" />
                </ListItemIcon>
                Profile
              </MenuItem>
              {/* <MenuItem onClick={handleProfileMenuClose} className="py-3 hover:bg-light">
                <ListItemIcon>
                  <SettingsIcon className="text-primary" />
                </ListItemIcon>
                Settings
              </MenuItem> */}
              <MenuItem onClick={logoutHandle} className="py-3 hover:bg-light">
                <ListItemIcon>
                  <LogoutIcon className="text-primary" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </div>

        </div>


      </div>


    </div>
  );
};

export default Headerbar;